import React from 'react'
import { formatBigMoney } from '../../packages/utils/numberFormatters'
import { useTranslation } from 'react-i18next'
import { NewsItem } from 'types/NewsItem'

export const NewsHeadlineConversion = ({ row }: { row: NewsItem }) => {
    const { i18n } = useTranslation()
    const locale = i18n.language
    const { convertibleData, companyName, currency } = row

    return (
        <span>
            {companyName} cirka{' '}
            {formatBigMoney(convertibleData.conversionAmount as number, { currencySymbol: currency, locale })}{' '}
            konverteras till aktier
        </span>
    )
}
